import { gql } from "@apollo/client";

export const IS_LOGGED_IN = gql`
  query IsUserLoggedIn {
    isLoggedIn @client
  }
`;

export const GET_UNPROCESSED_ABUSE_REPORTS = gql`
  query getAbuseReports {
    abuseReports(processed: false) {
      _id
      description
      processed
      reasonId
      reason
      subreasonId
      subreason
      courseId
      contentId
      contentTitle
      contentType
      contentDetails
      parentContentId
      parentContentType
      contentContributor
      contributor {
        username
      }
      createdAt
      updatedAt
    }
  }
`;

export const GET_PROCESSED_ABUSE_REPORTS = gql`
  query getAbuseReports {
    abuseReports(processed: true) {
      _id
      description
      processed
      reasonId
      reason
      subreasonId
      subreason
      contentId
      courseId
      contentTitle
      contentType
      contentDetails
      parentContentId
      parentContentType
      contentContributor
      contributor {
        username
      }
      createdAt
      updatedAt
      reviews {
        noteToBlag
        messageToContentCreator
        messageToReporter
        blockContent
        createdAt
        updatedAt
        reviewer {
          username
        }
      }
    }
  }
`;

export const GET_USER_HEADER = gql`
  query user {
    user {
      _id
      username
      profilePicture
      isAdmin
    }
  }
`;
